import React from 'react'

import { Chip } from '@/components/Chip/Chip'

interface SheetCardTypes {
  content: string | undefined
}

export const InputCardChip = ({ content }: SheetCardTypes) => {
  return content && <Chip variant="blue" size="large" text={content} />
}
